import { atom } from 'jotai';
import { userAtom as authShellUserAtom } from '@lotlinx-aws/auth-shell';

import { User } from 'types/User';

/** Use `userAtom` instead -- this atom should only be used in tests, to set an initial value */
export const userAtom_INTERNAL = authShellUserAtom;

/** The logged in user's data, undefined if not authenticated.
 *  Delegates to auth-shell's userAtom while preserving turn4's extended User type. */
export const userAtom = atom(
  (get) => get(authShellUserAtom) as User | undefined,
  (_get, set, newData: User | undefined) => {
    set(authShellUserAtom, newData);
  },
);
